import React from 'react';
import { useOnClickOutside } from '../Hooks/useOnClickOutside';
import { useRef } from 'react';

function PopupWithUseClickOutside(props) {
	const { isPopupVisible, onHidePopup, children } = props;
	const ref = useRef();
	useOnClickOutside(ref, () => onHidePopup());
	return (
		<div>
			{isPopupVisible ? (
				<div className="popup">
					<div className="popup-inner" ref={ref} style={props.style}>
						{children}
					</div>
				</div>
			) : null}
		</div>
	);
}

export default PopupWithUseClickOutside;
